<ng-container *ngIf="isDataExist;then showTable else emptyPlaceHolder"></ng-container>

<ng-template #showTable>
	<div class="mat-elevation-z8 table-container">
		<table mat-table matSort [dataSource]="dataSource"
					 #MatSortPolicyProductWaivers="matSort">

			<ng-container [matColumnDef]="tableColumns.Product">
				<th *matHeaderCellDef mat-header-cell mat-sort-header>Product</th>
				<td *matCellDef="let row" mat-cell> {{row.product?.name}}</td>
			</ng-container>

			<ng-container [matColumnDef]="tableColumns.Person">
				<th *matHeaderCellDef mat-header-cell mat-sort-header>Person</th>
				<td *matCellDef="let row" mat-cell> {{row.person?.name}}</td>
			</ng-container>

			<ng-container [matColumnDef]="tableColumns.ProductWaivers">
				<th *matHeaderCellDef mat-header-cell mat-sort-header>Waiver</th>
				<td *matCellDef="let row" mat-cell> {{row.productWaivers?.name}}</td>
			</ng-container>

			<ng-container [matColumnDef]="tableColumns.CustomWaiverValue">
				<th *matHeaderCellDef mat-header-cell mat-sort-header>Value</th>
				<td *matCellDef="let row" mat-cell> {{row.customWaiverValue}}</td>
			</ng-container>

			<ng-container [matColumnDef]="tableColumns.StartDate">
				<th *matHeaderCellDef mat-header-cell mat-sort-header>Start Date</th>
				<td *matCellDef="let row" mat-cell> {{row?.startDate | date: dateFormat}}</td>
			</ng-container>

			<ng-container [matColumnDef]="tableColumns.EndDate">
				<th *matHeaderCellDef mat-header-cell mat-sort-header>End Date</th>
				<td *matCellDef="let row" mat-cell> {{row.endDate | date: dateFormat}}</td>
			</ng-container>

			<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
			<tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
		</table>


		<mat-paginator #MatPaginatorPolicyProductWaivers="matPaginator"
									 [pageIndex]="paginatorControls.pageNumber"
									 [pageSize]="paginatorControls.pageSize"
									 [pageSizeOptions]="paginatorControls.pageSizeOptions">
		</mat-paginator>

	</div>
	<ng-container [ngTemplateOutlet]="PrevAndNextButtons"></ng-container>
</ng-template>

<ng-template #emptyPlaceHolder>
	<div class="text-center">
		<label class="column-label claim-column-label">The policy has no waivers</label>
	</div>
	<ng-container [ngTemplateOutlet]="PrevAndNextButtons"></ng-container>
</ng-template>

<ng-template #PrevAndNextButtons>
	<div class="button-container">
		<button mat-raised-button matStepperPrevious color="primary">Back</button>
		<button mat-raised-button disabled color="warn">Clear</button>
		<ng-content></ng-content>
	</div>
</ng-template>
